import { reducerWithInitialState } from 'typescript-fsa-reducers';
import ldCloneDeep from 'lodash/cloneDeep';
import { actions } from '../../modules/Actions';
import { CooperationInfoList, Summary, summaryInfoInit } from '../../../external/LinkedDataApi';

export interface LinkedDataResultState {
  totalRecords: number;
  summary: Summary;
  cooperationInfoList: CooperationInfoList[];
  prevCooperationInfoList: CooperationInfoList[];
}

export const initialLinkedDataResultState: LinkedDataResultState = {
  totalRecords: 0,
  summary: summaryInfoInit,
  cooperationInfoList: [],
  prevCooperationInfoList: [],
};

export const LinkedDataResultReducer = reducerWithInitialState(initialLinkedDataResultState)
  .case(actions.linkedDataResult.updateTotalRecord, (state: LinkedDataResultState, payload: number) => {
    return { ...state, totalRecords: payload };
  })
  .case(actions.linkedDataResult.updateSummaryInfo, (state: LinkedDataResultState, payload: Summary) => {
    return { ...state, summary: payload };
  })
  .case(actions.linkedDataResult.updateCooperationInfoList, (state: LinkedDataResultState, payload: CooperationInfoList[]) => {
    return {
      ...state,
      prevCooperationInfoList: ldCloneDeep(state.cooperationInfoList),
      cooperationInfoList: payload,
    };
  });
